<template>
  <v-row>
    <v-col cols="12" class="mt-0 mb-1 pb-0 pt-2">
      <v-text-field
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="label"
        :prepend-inner-icon="icon"
        :disabled="disabled"
        v-model="local_value"
        :rules="validation_rules"
        :required="required"
        :type="type"
        :readonly="readonly"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextField",
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-pencil",
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String,Number],
      default: "",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: "",
    }
  },
  computed: {
    local_value: {
      get() {
        return this.value;
      },
      set(new_value) {
        this.$emit("input", new_value);
      },
    }
  }
};
</script>